
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IFromReplyto, IPublicUrls, ITimeline, IUpdateFromReplyto, IUpdateTimelineWizard } from './timeline-model';

@Injectable()
export class TimelinesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${TimelinesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/events/{eventId}/timelines';

    public getTimeline(id: string): Observable<SuccessResponse<ITimeline> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ITimeline>>(TimelinesService.URL.replace('{eventId}', id)).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getPublicUrls(id: string): Observable<SuccessResponse<IPublicUrls> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IPublicUrls>>(TimelinesService.URL.replace('{eventId}', id) + '/publicurls').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getFromReplyto(eventId: string): Observable<SuccessResponse<IFromReplyto> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IFromReplyto>>(TimelinesService.URL.replace('{eventId}', eventId) + '/sendersettings/').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addFromReplyto(model: IUpdateFromReplyto): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(TimelinesService.URL.replace('{eventId}', model.eventId) + '/sendersettings', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateFromReplyto(model: IUpdateFromReplyto): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(TimelinesService.URL.replace('{eventId}', model.eventId) + '/sendersettings', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
